module.exports = __webpack_public_path__ + "static/bboxMiami-Bytel-03ec2e4c1711bb941ca5f92f8f38a652.jpg";